'use client';

import { createHttpClient } from '@/lib/api/httpClient';
import { mapCoinBalanceList } from './mappers';
import type { CoinBalanceEntry } from './models';
import type { CoinBalancesResponse } from './types';

const walletHttp = createHttpClient({ baseUrl: process.env.NEXT_PUBLIC_API_WALLET_URL });

export async function fetchCoinBalances(): Promise<CoinBalanceEntry[]> {
  const response = await walletHttp.get<CoinBalancesResponse>('/coin-balances');
  return mapCoinBalanceList(response?.l ?? []);
}
